import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Input, DropMenuTrigger, DropMenu, Icon, Dialog, Checkbox, Button } from '@tencent/spaui';
import message from '@/utils/message';
import { withApi } from '@tencent/react-aio';
import PotentialStatusSelect from '@/components/PotentialStatusSelect';
import MessageBox from '@/components/MessageBox';
import { ACTION_RECORD_TYPE, POTENTIAL_SECOND_SEASON, PROGRESS_STATUS } from '@/constants/Constants';
import PotentialReasonSelect from '@/business-components/sale/PotentialReasonSelect';
import { reportSeasUserBehaviorCgi } from '@/api/operator/cgi/smb/common';
import _ from 'lodash';

const pageBaseInfo = { page1: '销售', page2: '公海池', page3: '', page4: '线索详情页' };

const Path2Page = {
  '/seas/leads': { ...pageBaseInfo, page3: '线索公海池' },
  '/seas/potentials': { ...pageBaseInfo, page3: '商机公海池' },
  '/seas/potentials-active': { ...pageBaseInfo, page3: '活跃商机公海池' },
  '/seas/potentials-silence': { ...pageBaseInfo, page3: '沉默商机公海池' },
};

function getReportData(obj) {
  const {
    page1,
    page2,
    page3,
    page4,
    query,
    eventName,
  } = obj;
  if (page1) {
    return { page1, page2, page3, page4, query, eventName };
  }
  const pathKey = Object.keys(Path2Page).find((path) => window.location.pathname.includes(path));
  return Path2Page[pathKey] || {};
}

function AddEditCommonDialog(props) {
  const { value, onChange, type } = props;
  return (
    <Dialog modalStyle={{ zIndex: 2000 }} useNewUI {...props} style={{ width: '300px' }} title={`${type === 'add' ? '添加' : '修改'}常用语`}>
      <Input value={value} onChange={onChange} />
    </Dialog>
  );
}
function DeleteCommonDialog(props) {
  return (
    <Dialog modalStyle={{ zIndex: 2000 }} useNewUI {...props} style={{ width: '300px' }}>
      确认删除该条常用语？
    </Dialog>
  );
}
function LinkComponent(props) {
  const { className, onClick, children, data, value, onDelete, onCommonShow } = props;
  // 是否是根据onClick来的，所以需要响应下onClick

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }} className={className}>
      <p style={{ padding: '10px', flex: '1' }} onClick={() => onClick({ target: { value: data.label } })}>
        {children}
      </p>
      <span style={{ padding: '10px' }}>
        <Icon name="edit-outlined" onClick={(e) => onCommonShow(e, 'edit', data.label, data.value)} className="menu-icon" />
        <Icon name="delete-outlined" onClick={(e) => onDelete(e, data.value)} className="menu-icon" />
      </span>
    </div>
  );
}

class CreateActionRecordModal extends React.Component {
  static propTypes = {
    webApi: PropTypes.object.isRequired,
    lead: PropTypes.object.isRequired,
    potential: PropTypes.object,
    onSubmit: PropTypes.func.isRequired,
    claimWebApiName: PropTypes.func, // 申领请求方法
    claimParams: PropTypes.object, // 申领请求参数
    claimShow: PropTypes.bool, // 申领选项展示
  }

  constructor(props) {
    super(props);
    this.initState = {
      commonData: [],
      common: '',
      commonId: null,
      commonDialogShow: false,
      deleteShow: false,
      commonDialogType: 'add',
      dropMenuShow: false,
      claim: false,
    };
    if (props.potential) {
      const { potentialStatus, transactionProbability, customerId, customerMpUserName, firstPaymentAmount, serviceFee, potentialSecondSeasonType } = props.potential;
      this.state = {
        ...this.initState,
        potentialStatus,
        transactionProbability,
        potentialSecondSeasonType,
        customer: {
          value: customerMpUserName || customerId,
        },
        firstPaymentAmount,
        serviceFee,
      };
    } else {
      this.state = { ...this.initState };
    }
    this.commonShow = this.commonShow.bind(this);
    this.commonChange = this.commonChange.bind(this);
    this.deleteCommon = this.deleteCommon.bind(this);
    this.handleDeleteShow = this.handleDeleteShow.bind(this);
    this.handleDropMenuHide = this.handleDropMenuHide.bind(this);
  }

  render() {
    const { lead, potential, claimShow } = this.props;
    const {
      description,
      commonDialogShow,
      submitting,
      error,
      deleteShow,
      common,
      dropMenuShow,
      commonDialogType,
      commonData,
    } = this.state;
    const Content = (props) => {
      const [inputValue, setInputValue] = useState(props.iptValue);
      return (
        <div>
          {
            potential
            && lead?.progressStatus === PROGRESS_STATUS.PROGRESS_STATUS_POTENTIAL
            && this.renderPotential(potential)
          }
          <FormGroup className={'required with-textarea'}>
            <label htmlFor={'description'}>跟进情况：</label>
            <div style={{ display: 'flex' }}>
            <textarea
              id={'description'}
              className="spaui-input"
              minLength={3}
              value={inputValue}
              onChange={(e) => {
                setInputValue(e.target.value);
              }}
              onBlur={() => {
                props.setIpt({ target: { value: inputValue } });
              }}
            />
              <DropMenuTrigger
                alignment="right"
                open={dropMenuShow}
                dropMenu={
                  <DropMenu
                    data={commonData}
                    style={{ minWidth: '558px' }}
                    LinkComponent={LinkComponent}
                    footer={
                      <p onClick={(e) => this.commonShow(e, 'add')} style={{ textAlign: 'center' }}>
                        <Icon name="cross" />
                      </p>
                    }
                    LinkComponentProps={{
                      onClick: this.handleChangeDescription,
                      onCommonShow: this.commonShow,
                      onDelete: this.handleDeleteShow,
                    }}
                  />
                }
              >
                <div style={{ border: '1px solid rgba(57,73,103,.18)', borderLeft: 'none' }}>
                <span
                  style={{ padding: '20px', display: 'block' }}
                  onClick={() => {
                    this.setState({ dropMenuShow: !dropMenuShow });
                  }}
                >
                  <Icon name="feedback-outlined" style={{ width: '20px' }} />
                </span>
                </div>
              </DropMenuTrigger>
            </div>
          </FormGroup>
          { claimShow && this.renderClaimOption() }
          {error && (
            <p className={'has-error'}>
              <span className={'error-message'}>发生错误：{error.message || '服务器错误'}</span>
            </p>
          )}
        </div>
      );
    };
    if (this.props.notDialog) {
      return (
        <div className="phone-follow-up-content CreateActionRecordModal">
          <h4>添加跟进记录</h4>
          <Content iptValue={description} setIpt={this.handleChangeDescription} />
          <AddEditCommonDialog
            show={commonDialogShow}
            value={common}
            type={commonDialogType}
            onSubmit={this.saveCommon}
            onChange={this.commonChange}
            onCancel={() => this.setState({ commonDialogShow: false })}
            onClose={() => this.setState({ commonDialogShow: false })}
          />
          <DeleteCommonDialog
            show={deleteShow}
            onSubmit={this.deleteCommon}
            onCancel={() => this.setState({ deleteShow: false })}
            onClose={() => this.setState({ deleteShow: false })}
          />
          <div className="phone-follow-up-content-confirm">
            <Button onClick={this.handleSubmit}>确定</Button>
          </div>
        </div>
      );
    }
    return (
      <Dialog className="CreateActionRecordModal" title="添加跟进记录" subTitle={lead?.company?.companyName} {...this.props} style={{ width: 640 }} onSubmit={this.handleSubmit} disabled={submitting} type="normal" moveable>
        <Content iptValue={description} setIpt={this.handleChangeDescription} />
        <AddEditCommonDialog
          show={commonDialogShow}
          value={common}
          type={commonDialogType}
          onSubmit={this.saveCommon}
          onChange={this.commonChange}
          onCancel={() => this.setState({ commonDialogShow: false })}
          onClose={() => this.setState({ commonDialogShow: false })}
        />
        <DeleteCommonDialog
          show={deleteShow}
          onSubmit={this.deleteCommon}
          onCancel={() => this.setState({ deleteShow: false })}
          onClose={() => this.setState({ deleteShow: false })}
        />
      </Dialog>
    );
  }
  commonShow(e, type, common = '', commonId = null) {
    this.setState({
      common,
      commonId,
      commonDialogShow: true,
      commonDialogType: type,
    });
  }
  saveCommon = () => {
    const { webApi } = this.props;
    const { commonId: id, common: content, commonDialogType } = this.state;
    if (commonDialogType === 'add') {
      webApi
        .addRecordTemplate()
        .ajaxJson({ data: { content } })
        .then(
          (res) => {
            this.setState({ commonDialogShow: false }, (_) => this.getCommonData());
          },
          (error) => {
            this.context.error('创建常用语失败', error.message);
          },
        );
    } else {
      webApi
        .updateRecordTemplate()
        .ajaxJson({ data: { id, content } })
        .then(
          (res) => {
            this.setState({ commonDialogShow: false }, (_) => this.getCommonData());
          },
          (error) => {
            this.context.error('修改常用语失败', error.message);
          },
        );
    }
  }
  commonChange(e, value) {
    this.setState({ common: value });
  }
  deleteCommon() {
    const { webApi } = this.props;
    const data = { id: this.state.commonId };
    webApi
      .deleteRecordTemplate()
      .ajaxJson({ data })
      .then(
        (res) => {
          this.setState({ deleteShow: false, commonId: null }, (_) => {
            this.getCommonData();
          });
        },
        (error) => {
          this.context.error('删除常用语失败', error.message);
        },
      );
  }
  handleDropMenuHide() {
    this.setState({ dropMenuShow: false });
  }
  handleDeleteShow(e, id = null) {
    this.setState({ deleteShow: true, commonId: id });
  }
  getCommonData = () => {
    const { webApi } = this.props;
    webApi
      .findRecordTemplate()
      .ajaxJson()
      .then(
        (res) => {
          const commonData = _.map(res || [], (v) => {
            return {
              label: v.content,
              value: v.id,
            };
          });
          this.setState({ commonData: [{ name: '', list: commonData }] });
        },
        (error) => {
          this.context.error('获取常用语失败', error.message);
        },
      );
  }
  componentDidMount() {
    this.getCommonData();
  }
  renderPotential(potential) {
    const { potentialStatus, transactionProbability, potentialSecondSeasonType } = this.state;
    return (
      <React.Fragment>
        <FormGroup className={'with-select required'}>
          <label htmlFor={'potentialStatus'}>商机状态：</label>
          <PotentialStatusSelect id={'potentialStatus'} mode={'block'} potentialStatus={potentialStatus} transactionProbability={transactionProbability} onChange={this.handleChangePotentialStatus} />
        </FormGroup>
        {
          potentialStatus && <FormGroup className={'with-select required'}>
            <label htmlFor={'potentialStatus'}>意向原因：</label>
            <PotentialReasonSelect
              potentialStatus={`${potentialStatus}-${transactionProbability}`}
              value={potentialSecondSeasonType !== POTENTIAL_SECOND_SEASON.POTENTIAL_SECOND_SEASON_UNKNOWN ? potentialSecondSeasonType : undefined}
              onChange={this.handlePotentialSecondSeasonType}
            />
          </FormGroup>
        }
      </React.Fragment>
    );
  }

  /**
   * @description: 申领复选框
   */
  renderClaimOption = () => {
    return (
      <div>
        <lable style={{ marginRight: 20 }}>是否申领该线索</lable>
        <Checkbox
          label='申领'
          value={true}
          checked={!!this.state.claim}
          onChange={this.handleClaim}
        />
      </div>
    );
  }

  handleClaim = (e, claim) => {
    this.setState({ claim: claim || false });
  }

  handleChangePotentialStatus = (e, value) => {
    const { potentialStatus, transactionProbability } = value;
    this.setState({
      potentialStatus,
      transactionProbability,
      error: undefined,
      potentialSecondSeasonType: undefined,
    });
  }

  handlePotentialSecondSeasonType = (e, potentialSecondSeasonType) => {
    this.setState({ potentialSecondSeasonType });
  }

  handleChangeDescription = (e) => {
    this.setState({
      description: e.target.value,
      dropMenuShow: false,
      error: undefined,
    });
  }

  handleChangeCustomerId = (e, value) => {
    this.setState({
      customer: value.customer,
      customerStatus: value.status,
      customerError: value.error,
      error: value.error ? { message: value.error } : undefined,
    });
  }

  handleChangeFirstPaymentAmount = (e, value) => {
    this.setState({
      firstPaymentAmount: value,
      error: undefined,
    });
  }

  handleChangeServiceFee = (e, value) => {
    this.setState({
      serviceFee: value,
      error: undefined,
    });
  }

  handleSubmit = async () => {
    const { potentialStatus, transactionProbability, description, customer, customerStatus, firstPaymentAmount, serviceFee, potentialSecondSeasonType } = this.state;
    const {
      webApi,
      lead: { leadId, progressStatus },
      potential,
      onSubmit,
      comment,
    } = this.props;

    // 数据校验
    if (potential) {
      if (potentialStatus === 'POTENTIAL_STATUS_NEW') {
        return;
      }
      // 商机阶段商机状态，商机原因必填校验
      if (progressStatus === PROGRESS_STATUS.PROGRESS_STATUS_POTENTIAL && (!potentialStatus || !potentialSecondSeasonType || potentialSecondSeasonType === POTENTIAL_SECOND_SEASON.POTENTIAL_SECOND_SEASON_UNKNOWN)) {
        return;
      }
      if (potential?.transactionProbability !== transactionProbability) {
        if (transactionProbability === 100) {
          // 客户 ID 非必填
          // if (!customerIdOrMpUserName) {
          //   return;
          // }
          if (customerStatus && customerStatus !== 'success') {
            console.debug(`invalid customerStatus: ${customerStatus}`);
            return;
          }
          if (!firstPaymentAmount || firstPaymentAmount <= 0) {
            console.debug(`invalid firstPaymentAmount: ${firstPaymentAmount}`);
            return;
          }
          if (!serviceFee || serviceFee < 0) {
            console.debug(`invalid serviceFee: ${serviceFee}`);
            return;
          }
        }
      }
    }
    if (!description) {
      return;
    }

    // 提交
    this.setState({
      submitting: true,
      error: undefined,
    });

    const {
      page1,
      page2,
      page3,
      page4,
      query,
    } = getReportData(this.props);

    const reportData = {
      page1,
      page2,
      page3,
      page4,
      leadId,
      query,
      eventName: '策略二期',
    };

    // 公海勾选申领，则申领
    if (this.state.claim) {
      reportSeasUserBehaviorCgi({ data: { ...reportData, behavior: '申领' } });
      const res = await this.claimFunc();
      if (!res) {
        this.setState({ submitting: false });
        return;
      }
    }

    reportSeasUserBehaviorCgi({ data: { ...reportData, behavior: '跟进' } });

    webApi
      .addActionRecord(leadId)
      .ajaxJson({
        data: {
          potentialStatus,
          transactionProbability,
          description,
          customerId: transactionProbability === 100 && customer ? customer.customerId : undefined,
          customerMpUserName: transactionProbability === 100 && customer && customer.mp ? customer.mp.mpUserName : undefined,
          firstPaymentAmount: transactionProbability === 100 ? parseFloat(firstPaymentAmount) : undefined,
          serviceFee: transactionProbability === 100 ? parseFloat(serviceFee) : undefined,
          actionType: comment && potential && potential?.relationship ? ACTION_RECORD_TYPE.ACTION_TYPE_ADD_ANNOTATION : undefined,
          potentialSecondSeasonType,
        },
      })
      .then(
        (resp) => {
          this.setState({
            submitting: false,
          });
          message.success('编辑成功');
          onSubmit(resp);
        },
        (error) => {
          this.setState({
            submitting: false,
            error,
          });
        },
      );
  }

  /**
   * @description: 申领
   */
  claimFunc = async () => {
    const { webApi, claimWebApiName, claimParams } = this.props;
    const fetchFunc = webApi[claimWebApiName];
    if (!fetchFunc) return;
    return await fetchFunc()
      .ajaxJson({
        data: claimParams,
      })
      .then(
        (res) => {
          return res;
        },
        (error) => {
          this.context.error('申领失败', error.message);
        },
      );
  }
}

export default withApi(CreateActionRecordModal);

CreateActionRecordModal.contextType = MessageBox;
